import React from "react";
import { Col, Card, CardHeader, Row } from "../../components/ui";
import { Link } from "react-router-dom";
import { getAllEnabledProducts } from "../../api";
import { buildRegisterPath } from "../../utils/affiliateTracking";
import "./PlansCards.scss";

const getMonthsInCycle = (billingCycle) => {
  if (billingCycle === 12 || billingCycle === 365) return 12;
  if (billingCycle === 1 || billingCycle === 30) return 1;
  if (billingCycle === 3 || billingCycle === 92) return 3;
  return null;
};

const getBadgeVariant = (planName) => {
  const name = (planName || "").toLowerCase();
  if (name === "quarterly") return "accent";
  if (name === "annual" || name === "yearly") return "value";
  return "neutral";
};

export default class PlansCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
    };
  }

  componentDidMount = async () => {
    const products = await getAllEnabledProducts();
    this.setState({ products: products.data });
  };

  plan = (billingCycle) => {
    if (billingCycle === 12 || billingCycle === 365) {
      return { name: "Yearly", interval: "billed every year (45% Discount)" };
    } else if (billingCycle === 1 || billingCycle === 30) {
      return { name: "Monthly", interval: "billed every month" };
    } else if (billingCycle === 3 || billingCycle === 92) {
      return { name: "Quarterly", interval: "billed every quarter" };
    } else {
      return {};
    }
  };

  render() {
    const isPaywall = this.props.variant === "paywall";
    const cardBackground = isPaywall ? null : this.props.bg;

    return (
      <Row
        style={{
          paddingBottom: this.props.noPadding ? {} : "154px",
          paddingTop: this.props.paddingTop,
        }}
        className={`plans-cards-row justify-content-md-center${
          this.props.variant ? ` plans-cards-row--${this.props.variant}` : ""
        }`}
      >
        {this.state.products.map((plan) => {
          const isPopular = plan.name.toLowerCase() === "quarterly";
          const monthsInCycle = getMonthsInCycle(plan.billingCycle);
          const monthlyEquivalent =
            monthsInCycle && monthsInCycle > 1
              ? Math.round(plan.cost / monthsInCycle)
              : null;
          const badgeVariant = getBadgeVariant(plan.name);
          const surfaceStyle = cardBackground
            ? { backgroundColor: cardBackground }
            : undefined;

          return (
            <Col
              md={{ size: 4 }}
              key={plan.id}
              className={isPopular ? "plan-card-col plan-card-col--popular" : "plan-card-col"}
            >
              <Card
                small
                className={`plan-card${isPopular ? " plan-card--popular" : ""}`}
                style={surfaceStyle}
              >
                {isPopular && (
                  <div className="plan-card__ribbon">Most Popular</div>
                )}
                <CardHeader
                  className="plan-card__header text-center"
                  style={surfaceStyle}
                >
                  <h5 className="plan-card__title">{plan.name.toUpperCase()}</h5>
                  <span
                    className={`plan-card__badge plan-card__badge--${badgeVariant}`}
                  >
                    {plan.marketingPhrase}
                  </span>
                  <span className="plan-card__interval">
                    {this.plan(plan.billingCycle).interval}
                  </span>
                  <div className="plan-card__pricing">
                    <div className="plan-card__price">
                      <span className="plan-card__price-currency">$</span>
                      <span className="plan-card__price-amount">{plan.cost}</span>
                    </div>
                    <span
                      className={`plan-card__price-equivalent${
                        monthlyEquivalent == null
                          ? " plan-card__price-equivalent--spacer"
                          : ""
                      }`}
                    >
                      {monthlyEquivalent != null
                        ? `~$${monthlyEquivalent}/mo`
                        : "\u00a0"}
                    </span>
                  </div>
                </CardHeader>
                <div className="plan-card__description">{plan.description}</div>
                <Link
                  to={buildRegisterPath(plan.id)}
                  className="plan-card__cta plan-card__cta--primary"
                >
                  Get Started
                </Link>
              </Card>
            </Col>
          );
        })}
      </Row>
    );
  }
}
